import { memo } from "react";

import { Grid } from "@mui/material";

import { DateTime } from "luxon";

import constants, { constant_names } from "../../../../../utils/constants";
import LitcoLogo from "../../../../../images/LitcoLogo";

export default memo(function ConsultSubHeader(props) {
  const { meetingType, branchInfo, meetingDateTime } = props;

  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item>
        <table>
          <tbody>
            <tr>
              <td>Meeting Type:&emsp;</td>
              <td>{constant_names.MEETING_TYPE_NAMES[meetingType]}</td>
            </tr>

            {meetingType === constants.MEETING_TYPES.IN_PERSON && (
              <>
                <tr>
                  <td>Address:&emsp;</td>
                  <td>{branchInfo.address}</td>
                </tr>
                <tr>
                  <td>City:&emsp;</td>
                  <td>{branchInfo.city}</td>
                </tr>
              </>
            )}

            <tr>
              <td>Date and Time:&emsp;</td>
              <td>{DateTime.fromISO(meetingDateTime).toLocaleString(DateTime.DATETIME_MED)}</td>
            </tr>
          </tbody>
        </table>
      </Grid>

      <Grid item display={{ xs: "none", sm: "block" }}>
        <LitcoLogo opacity={0.4} size={30} />
      </Grid>
    </Grid>
  );
});
